
import clipboard from ".././../../assets/icons/clipboard.svg";
import file from ".././../../assets/icons/file_icon.png";
const icons = {
    clipboard,
    file,
};

export default icons;